var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920.372,
    height: 477.62,
    viewBox: "0 0 1920.372 477.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 -2762)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(1770 2762)",
    fill: "#6317ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(1743 2882)",
    fill: "#6317ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(1856 2837)",
    fill: "#6317ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M0,3111.693H1088.317s235.778-.589,389.69-91,332.979-242.669,441.732-242.669c.329.1.629,1.671.629,1.671s.009,30.382,0,33.719c-.075,27.046,0,298.3,0,298.3H1088.317Z",
    transform: "translate(0 127.908)",
    fill: "#6317ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,3135.623H1088.317s235.778-.631,389.69-97.527,332.979-260.073,441.732-260.073c.329.106.629,1.791.629,1.791s.009,32.561,0,36.137c-.075,28.986,0,319.692,0,319.692H1088.317Z",
    transform: "translate(0 103.977)",
    fill: "rgba(99,23,255,0.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.8708dc0db5ccf2e8f1a9cfad44a988a5.svg";
export { ForwardRef as ReactComponent };